<template>
  <div>
    <div class="row">

      <div class="col-sm mw-480 mb-4" style="white-space: nowrap;">
        <div class="text-left"><a href="-&quot;#&quot;" @click.prevent="do_prev">&lt;&lt; Previous</a></div>
      </div>
      <div class="col-sm mw-480 mb-4" style="white-space: nowrap;">
        <div class="text-center">Show <input v-model="months" class="text-center" maxlength="3"
                                             name="cal_months"
                                             size="2"
                                             type="number"> Months
        </div>
      </div>
      <div class="col-sm mw-480 mb-4 text-right" style="white-space: nowrap;">
        <a href="-&quot;#&quot;" @click.prevent="do_next">Next &gt;&gt;</a>
      </div>
    </div>
    <div class="row">
      <CalendarMonth v-for="index in int_months" v-if="twelve_months[index-1+offset]"
                     :month="twelve_months[index-1+offset].month"
                     :sku_id="sku_id"
                     :year="twelve_months[index-1+offset].year"></CalendarMonth>
    </div>
  </div>
</template>

<script>

import CalendarMonth from "@/components/CalendarMonth.vue";

export default {
  name: 'App',
  components: {CalendarMonth},
  data()
  {
    return {
      sku_id: null,
      months: null,
      cal_state: 'init',
      twelve_months: [],
      offset: 0
    }
  },
  methods: {
    do_next()
    {
      if (this.offset + this.int_months < 12)
      {
        this.offset += this.int_months
      }
      else
      {
        this.offset = 12 - this.int_months
      }
    },
    do_prev()
    {
      if (this.int_months < this.offset)
      {
        this.offset -= this.int_months
      }
      else
      {
        this.offset = 0
      }
    }
  },
  computed: {
    int_months: {
      get()
      {
        return Math.min(Number(this.months), 12)
      },
      set(val)
      {
        this.months = val
      }
    }
  },
  mounted()
  {
  },
  created()
  {
    this.sku_id = this.$parent.sku_id
    this.months = parseInt(this.$parent.months)

    let server = window.location.hostname === 'localhost' ? 'http://localhost' : ''

    this.$http.get(
        server + "/ws/get_twelve_months",
        {}).then(response =>
                 {
                   this.twelve_months = response.data.months

                   if (sessionStorage.getItem('search_form_data'))
                   {
                     const form_data = JSON.parse(sessionStorage.getItem('search_form_data'))
                     let date_bits = form_data.start_date.split('-')

                     for (let month in this.twelve_months)
                     {
                       if (this.twelve_months[month].month === parseInt(date_bits[1])
                           && this.twelve_months[month].year === parseInt(date_bits[0]))
                       {
                         this.offset = parseInt(month)
                         break
                       }
                     }
                   }

                 }).catch(err =>
                          {
                            this.cal_state = 'error'
                          })
  }
}
</script>

<style>
</style>
